import React from 'react';
import { ConfidenceRanking } from 'dea-core';
import img from '../../assets/images/global-rank-intro.svg';
import voAudio from '../../assets/vo/Opioid-M-One-12-NEW.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript:
    'At the beginning of the module, we asked about your familiarity with why we have an opioid epidemic. Select the image that matches how you feel now.'
};

const question =
  'I know why prescription opioid misuse, heroin use, and illicit fentanyl use have become an epidemic.';
const lead =
  'Select the image that matches how strongly you agree or disagree with the sentence.';

export default {
  title: 'What do You Think? Question 1',
  path: '/evaluate/confidence-ranking',
  content: (
    <ConfidenceRanking question={question} image={img} vo={vo} lead={lead} />
  )
};



// WEBPACK FOOTER //
// ./src/data/evaluate/ConfidenceRanking.js